/**
 * HelloUserResumeController class handles data loading, saving, and clearing operations.
 * It interacts with an API to fetch and store data, and provides methods to manage the data state.
 * 
 * @class
 * @param {Object} $scope - AngularJS scope object.
 * @param {Object} $http - AngularJS HTTP service for making API requests.
 * @param {Object} $timeout - AngularJS timeout service for scheduling tasks.
 */
class HelloUserResumeController {
    /**
     * Constructs a new instance of HelloUserResumeController.
     * 
     * @constructor
     * @param {Object} $scope - AngularJS scope object.
     * @param {Object} $http - AngularJS HTTP service for making API requests.
     * @param {Object} $timeout - AngularJS timeout service for scheduling tasks.
     */
    constructor($scope, $http, $timeout) {
        this.$scope = $scope;
        this.$http = $http;
        this.$timeout = $timeout;

        this.data = [];
        this.loading = false;

        // Bind methods to the current instance to ensure correct context when called from the scope.
        $scope.loadData = this.loadData.bind(this);
        $scope.saveData = this.saveData.bind(this);
        $scope.clearData = this.clearData.bind(this);
    }

    /**
     * Loads data from the API.
     * Sets the loading state to true during the request and handles success and error cases.
     * 
     * @method
     */
    loadData() {
        this.loading = true;
        this.$http.get('/api/data').then(response => {
            this.data = response.data;
            this.loading = false;
        }).catch(error => {
            console.error('Error loading data', error);
            this.loading = false;
        });
    }

    /**
     * Saves the current data to the API.
     * Sets the loading state to true during the request and handles success and error cases.
     * 
     * @method
     */
    saveData() {
        this.loading = true;
        this.$http.post('/api/data', this.data).then(response => {
            console.log('Data saved successfully', response);
            this.loading = false;
        }).catch(error => {
            console.error('Error saving data', error);
            this.loading = false;
        });
    }

    /**
     * Clears the current data.
     * 
     * @method
     */
    clearData() {
        this.data = [];
        console.log('Data cleared');
    }
}

export default HelloUserResumeController;